export function locationMap() {
	document.addEventListener('DOMContentLoaded', function () {
		const mapWrappers = document.querySelectorAll('[data-map-locations]')

		mapWrappers.forEach(wrapper => {
			const mapElements = wrapper.querySelectorAll('[data-map-location]')

			mapElements.forEach(element => {
				const location = element.getAttribute('data-map-location')

				element.addEventListener('mouseenter', function () {
					const correspondingElements = wrapper.querySelectorAll(`[data-map-location="${location}"]`)
					correspondingElements.forEach(el => {
						if (el !== element) {
							el.classList.add('active')
						}
					})
				})

				element.addEventListener('mouseleave', function () {
					const correspondingElements = wrapper.querySelectorAll(`[data-map-location="${location}"]`)
					correspondingElements.forEach(el => {
						el.classList.remove('active')
					})
				})
			})
		})
	})
}
